import { __extends } from "tslib";
import React from "react";
import { withScope, captureException, showReportDialog } from "@sentry/browser";
var ErrorBoundary = (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { hasError: undefined, eventId: undefined };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function () {
        return { hasError: true };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        var _this = this;
        withScope(function (scope) {
            scope.setExtras(errorInfo);
            var eventId = captureException(error);
            _this.setState({ eventId: eventId });
        });
    };
    ErrorBoundary.prototype.render = function () {
        var _a = this.state, hasError = _a.hasError, eventId = _a.eventId;
        if (hasError) {
            return typeof eventId !== "string" ? (React.createElement("button", { onClick: function () { return showReportDialog({ eventId: eventId }); } }, "Report Feedback")) : null;
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(React.Component));
export { ErrorBoundary };
//# sourceMappingURL=index.js.map